export const useCommonStore = defineStore('common', {
    state: () => ({
        balance: 0,
        email: '',
    }),

    getters: {},

    actions: {
        setBalance(data: any) {
            this.balance = data
        },
        async getBindEmail() {
            try {
                const res = await clientFetch('/api/me/get-bind-email', {
                    method: 'GET',
                })
                console.log('获取绑定邮箱', res)
                if (res.code === 0) {
                    this.email = res.data.email
                }
            } catch (e) {
                console.log(e)
            }
        },
    },

})
